import React from 'react';

const FilterBar = ({
    searchTerm,
    setSearchTerm,
    isVegSelected,
    setIsVegSelected,
    isNonVegSelected,
    setIsNonVegSelected,
    selectedCategory,
    clearFilters,
    openScheduleModal
}) => {
    return (
        <div className="menu-filter-bar">
            <div className="menu-filter-left">
                <span className="menu-filter-label">Filters</span>
                {(searchTerm || isVegSelected || isNonVegSelected || selectedCategory !== "ALL") && (
                    <button className="menu-clear-filters" onClick={clearFilters}>✕ Clear</button>
                )}
            </div>
            <div className="menu-filter-right">
                <input
                    type="text"
                    placeholder="Search dish..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    className="menu-search-input"
                />
                <button
                    className={`menu-chip menu-chip--veg ${isVegSelected ? 'active' : ''}`}
                    onClick={() => { setIsVegSelected(!isVegSelected); setIsNonVegSelected(false); }}
                >🌱 Veg</button>
                <button
                    className={`menu-chip menu-chip--nonveg ${isNonVegSelected ? 'active' : ''}`}
                    onClick={() => { setIsNonVegSelected(!isNonVegSelected); setIsVegSelected(false); }}
                >🍗 Non-Veg</button>
                <button className="menu-schedule-btn" onClick={openScheduleModal}>📅 Book Table</button>
            </div>
        </div>
    );
};

export default FilterBar;